module.exports = __webpack_public_path__ + "static/media/yiyuan3.868c50e5.png";